<template>
  <div class="_login-app">
    <div class="login">
      <div class="logo-box">
        <div class="content">
          <div class="logo-pic">
            <div class="inner-pic">
              <el-image :src="require('../assets/logo.jpg')"></el-image>
            </div>
          </div>
          <div class="app-title">{{ $store.state.sys.title }}</div>
        </div>
      </div>
      <div class="login-box">
        <template v-if="!forget">
          <el-form ref="form" :model="data" size="large" style="width: 100%;" :rules="rules"
            @keyup.enter.native="login">
            <div class="title">用户登录</div>
            <el-form-item prop="LoginId">
              <el-input prefix-icon="el-icon-user" v-model="data.LoginId" placeholder="登录账号" />
            </el-form-item>
            <el-form-item prop="Pwd">
              <el-input prefix-icon="el-icon-lock" show-password type="password" v-model="data.Pwd"
                placeholder="登录密码" />
            </el-form-item>
            <!-- 验证码 -->
            <div style="display: flex;">
              <div style="width: 100%;">
                <el-form-item prop="VerifyCode">
                  <el-input  prefix-icon="el-icon-key" v-model="data.VerifyCode" placeholder="填写验证码" />
                </el-form-item>
              </div>
              <div style="padding-left:10px;">
                <s-identify :identifyCode="identifyCode" @refresh="refreshCode"></s-identify>
              </div>
            </div>
            <!-- <el-row>
              <el-col :span="$store.state.isMB ? 13 : 15" style="padding-right:10px;">
                <el-form-item prop="Code">
                  <el-input v-model="data.Code" placeholder="短信验证码" />
                </el-form-item>
              </el-col>
              <el-col :span="$store.state.isMB ? 11 : 9">
                <el-button :disabled="time != 0" style="width:100%" size="large" type="info" plain @click="sendCode(3)">
                  <span v-if="time == 0">点击获取</span>
                  <span v-else>{{ time }}s</span>
                </el-button>
              </el-col>
            </el-row> -->
            <el-button size="large" :loading="loading" type="primary" style="width:100%;" @click="login">登录</el-button>
            <!-- <span class="forget-pwd" @click="forgetPwd(true)">忘记密码</span> -->
          </el-form>
        </template>
        <template v-else>
          <el-form ref="form" size="large" :model="data" :rules="rules" @keyup.enter.native="login">
            <el-form-item prop="LoginId">
              <el-input size="large" v-model="data.LoginId" placeholder="手机号码" />
            </el-form-item>
            <el-form-item prop="Pwd">
              <el-input show-password type="password" v-model="data.Pwd" placeholder="登录密码" />
            </el-form-item>
            <el-row>
              <el-col :span="$store.state.isMB ? 13 : 15" style="padding-right:10px;">
                <el-form-item prop="Code">
                  <el-input v-model="data.Code" placeholder="短信验证码" />
                </el-form-item>
              </el-col>
              <el-col :span="$store.state.isMB ? 11 : 9">
                <el-button :disabled="time != 0" style="width:100%" type="info" plain @click="sendCode(4)">
                  <span v-if="time == 0">点击获取</span>
                  <span v-else>{{ time }}s</span>
                </el-button>
              </el-col>
            </el-row>
            <el-button size="large" :loading="loading" type="primary" style="width:100%;"
              @click="resetPwd">重置密码</el-button>
            <span class="forget-pwd" @click="forgetPwd(false)">返回登录</span>
          </el-form>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import sIdentify from "@/components/common/sIdentify";

export default {
  components: {
    sIdentify,
  },
  data() {
    const validateCode = (rule, value, callback) => {
      if (this.identifyCode !== value) {
        this.data.VerifyCode = "";
        this.refreshCode();
        callback(new Error("请输入正确的验证码"));
      } else {
        callback();
      }
    };
    return {
      api: require("@/api/sy/user").default,
      identifyCode: "",
      loading: false,
      data: {
        LoginId: "",
        Pwd: "",
        Code: "",
        VerifyCode: "",
      },
      forget: false, //忘记密码
      time: 0,
      interval: null,
      rules: {
        LoginId: [{ required: true, message: "请输入登录账号" }],
        Pwd: [{ required: true, message: "请输入登录密码" }],
        // Code: [{ required: true, message: "请输入短信验证码" }],
        VerifyCode: [
          { required: true, message: "请输入验证码" },
          { validator: validateCode, trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.refreshCode();
  },
  mounted() {
    this.$store.dispatch("getSysWebSetting");
    let token = localStorage.getItem("token");
    if (token) {
      this.$store.dispatch("refreshToken").then((res) => {
        if (res.Code == 0) {
          this.$router.push("/dashboard").catch((err) => { });
        }
      });
    }
  },
  methods: {
    //3:登录验证码 4:重置密码
    sendCode(type = 3) {
      this.api.sendCode(this.data.LoginId).then((res) => {
        if (res.Code == 0) {
          let self = this;
          self.time = 120;
          this.interval = setInterval(function () {
            self.time -= 1;
            if (self.time <= 0) {
              clearInterval(self.interval);
            }
          }, 1000);
        } else {
          if (res.Msg == null) {
            res.Msg = "发送失败";
          }
          this.$message.error(res.Msg);
        }
      });
    },
    forgetPwd(data) {
      this.forget = data;
      this.data.Code = "";
      clearInterval(this.interval);
      this.time = 0;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    login() {
      this.$refs.form.validate().then((res) => {
        if (!res) return false;
        this.loading = true;
        console.log(this.data.LoginId);

        this.$store.dispatch("login", this.data).then((res) => {
          // if (res.Data.ChangePwd == true) {
          //   this.$store.dispatch("changeSetting", {
          //     key: "fixedHeader",
          //     value: false,
          //   });
          //   this.$router.push("/password").catch((err) => {});
          // } else {
          // console.log("login", res);
          this.$store.dispatch('getNumericSetting')
          this.$store.dispatch('getProductSetting')
          this.$store.dispatch('getSaleSetting')
          this.$store.dispatch("getPurchaseSetting");
          this.$store.dispatch("getStockSetting")
          this.$router.push("/dashboard").catch((err) => { });
          // }
        }).catch((res) => {
          this.$message.error(res.Msg);
          this.loading = false;
          console.log(res);
        });
      }).catch((res) => {
        console.log(res);
      });
    },
    resetPwd() {
      this.$refs.form.validate().then((valid) => {
        if (!valid) return false;
        this.loading = true;
        this.api.resetPwd(this.data).then((res) => {
          this.loading = false;
          if (res.Code == 0) {
            this.forgetPwd(false);
            this.data.Pwd = "";
            this.data.Code = "";
            this.$message.success(res.Msg);
          } else {
            this.$message.error(res.Msg);
          }
        });
      }).catch((res) => {
        this.loading = false;
        console.log(res);
      });
    },
    refreshCode() {
      this.identifyCode = "";
      for (let i = 0; i < 4; i++) {
        this.identifyCode += this.randomNum(0, 9);
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
  },
};
</script>
<style lang="scss">
._login-app {
  height: 100vh;

  @media screen and (min-width: 768px) {
    background-image: url("../assets/bgPic.jpg");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    -moz-background-size: 100% 100%;
  }

  .login {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 780px;
    height: 390px;
    display: flex;
    z-index: 1000;
    border-radius: 12px;
    box-shadow: 2px 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;

    .logo-box {
      background-color: rgba(24, 76, 131, .85);
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .logo-pic {
          width: 180px;
          height: 180px;
          overflow: hidden;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.5);
          padding: 10px;

          .inner-pic {
            width: 160px;
            height: 160px;
            overflow: hidden;
            border-radius: 50%;
            background-color: #ffffff;
            padding: 15px;
          }
        }

        .app-title {
          margin-top: 15px;
          height: 40px;
          line-height: 40px;
          font-size: 26px;
          font-weight: bold;
          text-align: center;
          color: #ffffff;
        }
      }
    }

    .login-box {
      width: 50%;
      padding: 0 25px;
      background-color: #fff;
      display: flex;
      align-items: center;

      @media screen and (max-width: 480px) {
        width: 80%;
      }

      .title {
        height: 40px;
        font-weight: bold;
        font-family: "宋体";
        font-size: 20px;
        text-align: center;
        letter-spacing: 1px;
        color: #1f5b9a;

        @media screen and (max-width: 480px) {
          font-size: 18px;
        }
      }

      .forget-pwd {
        font-size: 16px;
        margin-top: 5px;
        display: inline-block;
        color: gray;
        cursor: pointer;
      }
    }
  }

}
</style>